import React, { type FC, type ElementType } from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import { HeadPage } from '@routes';
import { useStore } from '../../store/useStore';

interface IPrivateRouteProps {
  title?: string;
  component: ElementType;
}

const PrivateRoute: FC<IPrivateRouteProps> = ({
  component: Component,
  title,
}) => {
  const { isAuthenticated } = useStore();

  console.log(isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={'/login'} replace />;
  }

  return (
    <>
      {title && <HeadPage title={title} />}
      {Component ? <Component /> : <Outlet />}
    </>
  );
};

export default PrivateRoute;
